// extracted by mini-css-extract-plugin
export var standaloneTable = "_gj-0";
export var withExtraHeader = "_gj-1";